
import Layout from "@/components/Layout";
import PricingContent from "@/components/pricing/PricingContent";

const PricingPage = () => {
  return (
    <Layout>
      <PricingContent />
    </Layout>
  );
};

export default PricingPage;
